export const includesOneOf = (target: any[], pattern: any[]) => {
  let result = false;
  pattern.forEach((item) => {
    if (!result && target.includes(item)) result = true;
  });
  return result;
};
